/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Calendar } from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./Attendance.css";
import api from "../utils/Api";
import "./ParticularAttendance.css";
import { hitApi } from "../utils/apiCall";
import { useParams } from "react-router-dom";

const ParticularStudentAttendanceReport = () => {
  const { id, seid } = useParams();
  const [fetchedBasicData, setFetchedBasicData] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [attendanceDetails, setAttendanceDetails] = useState([]);

  const [attendanceMessage, setAttendanceMessage] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [showCalendar, setShowCalendar] = useState(true);

  // useEffect(() => {
  //   fetchToken(); // Fetch token on mount
  // }, []);

  useEffect(() => {
    // Initialize the current month's fromDate and toDate
    const currentMonthStart = getMonthStart(new Date());
    const currentMonthEnd = getMonthEnd(new Date());
    setFromDate(currentMonthStart);
    setToDate(currentMonthEnd);
  }, []);

  useEffect(() => {
    if (fromDate && toDate) {
      // Fetch attendance details when dates or token are set
      fetchAttendanceDetails(
        fetchedBasicData?.branch_id,
        fetchedBasicData?.session_id,
        fromDate,
        toDate
      );
    }
  }, [fetchedBasicData, fromDate, toDate]);

  const calculateAttendanceTotals = () => {
    const totalPresent = attendanceDetails?.filter(
      (entry) => entry.status === "P"
    ).length;
    const totalAbsent = attendanceDetails?.filter(
      (entry) => entry.status === "A"
    ).length;
    return { totalPresent, totalAbsent };
  };

  const fetchAttendanceDetails = async (bid, sid, fromDate, toDate) => {
    const token = localStorage.getItem("authToken");
    const enrollId = localStorage.getItem("enrollId");
    const branchId = localStorage.getItem("branchId");

    const fd = new FormData();
    fd.append("programType", "getStudentAttendance");
    fd.append("authToken", token);

    // fd.append("branch", branchId);
    fd.append("branch", bid);
    fd.append("session", sid);
    // fd.append("enrollId", enrollId);
    fd.append("enrollId", seid);
    fd.append("fromDate", fromDate);
    fd.append("toDate", toDate);

    try {
      // const response = await api.post("parentApp/studentCurl2", fd);
      const response = await hitApi(
        "parentApp/studentCurl2",
        "getStudentAttendance",
        fd
      );
      console.log("attendance", response.data);
      const data = response.data.data || [];
      // console.log("attendance", data)
      setAttendanceDetails(response.data);
    } catch (error) {
      console.error("Error fetching attendance details:", error);
    }
  };

  const getMonthStart = (date) => {
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    return start.toISOString().split("T")[0];
  };

  const getMonthEnd = (date) => {
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return end.toISOString().split("T")[0];
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
    const selectedDateStr = formatDate(date);

    const attendance = attendanceDetails.find(
      (entry) => formatDate(new Date(entry.date)) === selectedDateStr
    );

    if (attendance) {
      setAttendanceMessage(
  attendance.status === "P"
    ? "The Student was present"
    : attendance.status === "A"
    ? "The Student was absent"
    : "No Attendance Available" // 👈 for NA
);
    } else {
      setAttendanceMessage("Not found");
    }
    setShowDetails(true);
  };

  const onCalendarNavigate = (activeStartDate) => {
    const newFromDate = getMonthStart(activeStartDate);
    const newToDate = getMonthEnd(activeStartDate);
    setFromDate(newFromDate);
    setToDate(newToDate);
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

const tileClassName = ({ date, view }) => {
  if (view === "month") {
    const isWithinActiveMonth =
      date >= new Date(fromDate) && date <= new Date(toDate);

    if (isWithinActiveMonth) {
      // ✅ PRIORITY 1: Sunday
      if (date.getDay() === 0 && !isDateDisabled(date)) {
        return "sunday";
      }

      // ✅ PRIORITY 2: Attendance
      const dateStr = formatDate(date);
      const attendance = attendanceDetails.find(
        (entry) => formatDate(new Date(entry.date)) === dateStr
      );

      if (attendance) {
        if (attendance.status === "P") return "present";
        if (attendance.status === "A") return "absent";
        if (attendance.status === "NA") return "na";
      }
    }
  }
  return "";
};

  // Helper function to check if a date is disabled
  const isDateDisabled = (date) => {
    return date < new Date(fromDate) || date > new Date(toDate);
  };

const tileContent = ({ date, view }) => {
  if (view === "month") {
    const isWithinActiveMonth =
      date >= new Date(fromDate) && date <= new Date(toDate);

    if (isWithinActiveMonth) {
      // ✅ PRIORITY 1: Sunday → always orange
      if (date.getDay() === 0) {
        return (
          <div className="tile-content">
            <div className="dot sunday-dot"></div>
          </div>
        );
      }

      // ✅ PRIORITY 2: Attendance
      const dateStr = formatDate(date);
      const attendance = attendanceDetails.find(
        (entry) => formatDate(new Date(entry.date)) === dateStr
      );

      if (attendance) {
        return (
          <div className="tile-content">
            <div
              className={`dot ${
                attendance.status === "P"
                  ? "present"
                  : attendance.status === "A"
                  ? "absent"
                  : "na"
              }`}
            ></div>
          </div>
        );
      }
    }
  }
  return null;
};

  useEffect(() => {
    async function fetchBasicDetails(stdId, enrId) {
      const fd = new FormData();
      fd.append("studentId", stdId);
      fd.append("enrollId", enrId);
      const res = await hitApi(
        "admission/createAddmissionMain",
        "getStudentDetailsAllInfo",
        fd
      );
      if (res.success) {
        setFetchedBasicData(res.data[0]);
      } else {
        setFetchedBasicData(res.data[0]);
      }
    }
    fetchBasicDetails(id, seid);
  }, [id, seid]);

  return (
    <div className="page-content-wrapper py-3">
      <div className="container " style={{ marginTop: "0px" }}>
        <h2 className="page-title text-center" style={{ marginBottom: "0px" }}>
          Attendance
        </h2>
        <div className="card mb-3 shadow-sm ">
          <div className="card-body">
            {showCalendar && (
              <div
                className="calendar-container"
                style={{ border: "none", width: "auto" }}
              >
                <Calendar
                  onChange={handleDateClick}
                  onActiveStartDateChange={({ activeStartDate }) =>
                    onCalendarNavigate(activeStartDate)
                  }
                  value={selectedDate}
                  tileClassName={tileClassName}
                  tileContent={tileContent}
                  formatShortWeekday={(locale, date) =>
                    date.toLocaleDateString(locale, { weekday: "narrow" })
                  }
                  formatMonthYear={(locale, date) =>
                    date.toLocaleDateString(locale, {
                      month: "short",
                      year: "numeric",
                    })
                  }
                />
              </div>
            )}
          </div>
        </div>

        <div className="legend-container text-center mt-3">
          <div className="legend">
            <span className="dot present"></span> Present
            <span
              className="dot absent"
              style={{ marginLeft: "15px" }}
            ></span>{" "}
            Absent
            <span
              className="dot sunday-dot"
              style={{ marginLeft: "15px" }}
            ></span>{" "}
            Holiday
          </div>
        </div>

        <div className="card user-data-card mt-2 mb-5 ">
          {attendanceDetails.length > 0 &&
            (() => {
              const { totalPresent, totalAbsent } = calculateAttendanceTotals();
              return (
                <div className="card-body d-flex justify-content-around p-3 rounded shadow-md  text-center">
                  <div className="">
                    <p className="mb-1 text-success fw-bold">Total Present</p>
                    <h5 className="mb-0 fw-bold">{totalPresent}</h5>
                  </div>
                  <div>
                    <p className="mb-1 text-danger fw-bold">Total Absent</p>
                    <h5 className="mb-0 fw-bold">{totalAbsent}</h5>
                  </div>
                </div>
              );
            })()}
        </div>

        {showDetails && (
          <div className="mt-3">
            <h4 className="page-title">Attendance Details</h4>
            <p>{attendanceMessage}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ParticularStudentAttendanceReport;
